import { render, staticRenderFns } from "./WhatIsO2.vue?vue&type=template&id=2142ca91&"
import script from "./WhatIsO2.vue?vue&type=script&lang=js&"
export * from "./WhatIsO2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports